<template>
    <div class="cardpwd-fields">
        <div class='focusElements'>
            <input type="tel"
                    id="inputIdPass1"
                    placeholder="*"
                    v-model="password[0]"
                    @input='focusElement(1)'
                    v-maxLength='1'
                    v-replace='/^\D+$/'
                    @focus='selectElement(0)'
                    @keyup.delete="onDelete(0)"
                    ref="pass0">
        </div>
        <div class='focusElements'>
            <input type="tel"
                    id="inputIdPass2"
                    placeholder="*"
                    v-model="password[1]"
                    @input='focusElement(2)'
                    v-maxLength='1'
                    v-replace='/^\D+$/'
                    @focus='selectElement(1)'
                    @keyup.delete="onDelete(1)"
                    ref="pass1">
        </div>
        <div class='focusElements'>
            <input type="tel"
                    id="inputIdPass3"
                    placeholder="*"
                    v-model="password[2]"
                    @input='focusElement(3)'
                    v-maxLength='1'
                    v-replace='/^\D+$/'
                    @focus='selectElement(2)'
                    @keyup.delete="onDelete(2)"
                    ref="pass2">
        </div>
        <div class='focusElements'>
            <input type="tel"
                    id="inputIdPass4"
                    placeholder="*"
                    v-model="password[3]"
                    v-maxLength='1'
                    v-replace='/^\D+$/'
                    @focus='selectElement(3)'
                    @keyup.delete="onDelete(3)"
                    ref="pass3">
        </div>
    </div>
</template>

<script>
export default {
  name: 'InputSecurePass',
  data() {
    return {
      password: ['', '', '', ''],
    };
  },
  methods: {
    onDelete(index) {
      const prevIndex = index - 1;
      if (prevIndex < 0) return;
      this.selectElement(prevIndex);
      this.focusElement(prevIndex, true);
    },
    focusElement(index, toPrev = false) {
      if (toPrev) return this.$refs[`pass${index}`].focus();
      if (!this.password[index - 1]) return; // если не введена цифра, то не инициализируем евент фокус на след. элемент

      this.$refs[`pass${index}`].focus();
    },
    selectElement(index) {
      this.$refs[`pass${index}`].select();
    },
  },
  watch: {
    password: {
      handler(password) {
        this.$emit('passwordChangeHandler', this.password);
        if (password.every(el => el)) this.$emit('fieldsAreFilled', password);
      },
      deep: true,
    },
  },
};
</script>

<style lang="sass" scoped>
.cardpwd-fields
  display: flex
  justify-content: space-between
  position: relative
  margin-left: -10px
  margin-right: -10px
  .focusElements
    // width: 5rem
    flex-grow: 1
    margin: 0 10px
    text-align: center
    border-radius: 5px
    overflow: hidden
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    input
      font-size: 3.76rem
      line-height: 1
      text-align: center
      padding: 20px 10px
    
</style>
